export const HERO_CONSTANTS = {
  button: {
    label: "Revolutionize your network management today",
    link: "#contact-us",
  },
  title: "Cloud SecurityAutomate & Optimize Your IT Network",
};
